import { render } from "./App.vue?vue&type=template&id=2f38b634"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2f38b634&lang=css"

import exportComponent from "/codebuild/output/src2801517558/src/LetMC.PropertyMicroSite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__